import { render, staticRenderFns } from "./PortfolioStockSummary.vue?vue&type=template&id=0f058876&scoped=true&"
import script from "./PortfolioStockSummary.vue?vue&type=script&lang=js&"
export * from "./PortfolioStockSummary.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioStockSummary.vue?vue&type=style&index=0&id=0f058876&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f058876",
  null
  
)

export default component.exports